interface Props {
  message?: string;
}

export function ChartEmpty({ message = 'Aucune donnée pour cette période' }: Props): JSX.Element {
  return (
    <div className="flex items-center justify-center h-full min-h-[220px] text-sm text-slate-500">
      {message}
    </div>
  );
}
